import { useState } from 'react';
import { useCheckPaymentExpiration } from './Inbox/Notification/Reminders/hooks/useCheckPaymentExpiration';
import history from '~/browserHistory';
import { Colors } from '~/themes/colors';
import { routes } from '~/routes';
import { ConfirmPopup, WarningBanner } from '~/commonComponents';
import WarningIcon from '../images/warning-icon.svg';

interface IPaymentWarningBannerProps {
  officeId?: string;
  containerStyle?: React.CSSProperties;
}

export const PaymentWarningBanner = ({ officeId, containerStyle }: IPaymentWarningBannerProps) => {
  const [showAddPaymentPopup, setShowAddPaymentPopup] = useState(false);
  const { isInvalidPayment } = useCheckPaymentExpiration(officeId);

  if (!isInvalidPayment) {
    return null;
  }

  return (
    <>
      <WarningBanner
        description="Your payment method is either missing or expired. Please update it to unlock candidate names and send invites to professionals."
        onClick={() => setShowAddPaymentPopup(true)}
        containerStyle={containerStyle}
        primaryColor={Colors.error_500}
        secondaryColor="#FDF2F4"
        showRightArrow
      />

      {showAddPaymentPopup && (
        <ConfirmPopup
          title="Payment Method Missing or Expired"
          description="In order to invite a professional, please add or update your preferred payment method."
          leftButtonText="Go Back"
          leftButtonAction={() => setShowAddPaymentPopup(false)}
          rightButtonText="Add Payment"
          rightButtonAction={() => {
            setShowAddPaymentPopup(false);
            history.push(routes.paymentInformation);
          }}
          closePopup={() => setShowAddPaymentPopup(false)}
          Icon={() => <img src={WarningIcon} alt="Warning" style={{ marginBottom: 21 }} />}
        />
      )}
    </>
  );
};
